module.exports = __webpack_public_path__ + "static/media/bluedrink.70ac66cd.png";